var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0C2.16 0 0 2.16 0 4.8C0 8.04 4.2 11.7 4.38 11.88C4.5 11.94 4.68 12 4.8 12C4.92 12 5.1 11.94 5.22 11.88C5.4 11.7 9.6 8.04 9.6 4.8C9.6 2.16 7.44 0 4.8 0ZM4.8 10.62C3.54 9.42 1.2 6.84 1.2 4.8C1.2 2.82 2.82 1.2 4.8 1.2C6.78 1.2 8.4 2.82 8.4 4.8C8.4 6.78 6.06 9.42 4.8 10.62ZM4.8 2.4C3.48 2.4 2.4 3.48 2.4 4.8C2.4 6.12 3.48 7.2 4.8 7.2C6.12 7.2 7.2 6.12 7.2 4.8C7.2 3.48 6.12 2.4 4.8 2.4ZM4.8 6C4.14 6 3.6 5.46 3.6 4.8C3.6 4.14 4.14 3.6 4.8 3.6C5.46 3.6 6 4.14 6 4.8C6 5.46 5.46 6 4.8 6Z",
    fill: "#585D6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.162ad55b20e4354370299ff725fcff99.svg";
export { ForwardRef as ReactComponent };